module.exports = __webpack_public_path__ + "img/home-index-menu5.9eaca05f.png";